import React from "react";
import { VehiclesProvider } from "../Context/VehiclesContext";
import VehiclesContent from "./Vehicles/VehiclesContent";

const Vehicles = () => {
  return (
    <VehiclesProvider>
      <VehiclesContent />
    </VehiclesProvider>
  );
};

export default Vehicles;
